<div style="margin-left: 10px; margin-top: 12px; margin-right: 10px">
  <div class="title-container">
    <p class="text-align-center">Projects ({{ projectList.length }})</p>
    <div (mouseenter)="addEntities = true" (mouseleave)="addEntities = false" class="create-new"
      (click)="onProjectAdd()">
      <!-- <span [ngClass]="{'mouse-over-create-label':addEntities,'label-icon':true}" >&#xFF0B;</span> -->
      <!-- Tooltip sits on the wrapper, not the button: a disabled mat-raised-button gets the native
           disabled attribute and stops firing mouse events, so a tooltip on the button itself would
           never show while disabled - which is exactly when it needs to. -->
      <span class="create-new-tooltip-host"
        [matTooltip]="canCreateProject ? 'Create a new project' : 'You do not have permission'">
        <button mat-raised-button color="primary" class="create-new-button" [disabled]="!canCreateProject"
          (mouseover)="addEntities = true" (mouseout)="addEntities = false"
          [style.opacity]="canCreateProject && addEntities ? 0.7 : null">
          <span class="create-new-text">Create new project</span>
        </button>
      </span>
    </div>
  </div>

  <div style="padding: 5pxw" class="mat-elevation-z8">
    @if (isDetailedView) {
    <div class="controls-container">
      <div class="search-container">
        <div class="search-input-wrapper">
          <input type="text" class="filter-search-input" [(ngModel)]="textFilter" (ngModelChange)="applyTextFilter()" placeholder="Search projects..." aria-label="Search projects" />
          @if (textFilter && textFilter.length > 0) {
          <button type="button" class="search-clear-button" matTooltip="Clear search" matTooltipPosition="above" (click)="onSearchClear()" aria-label="Clear search">
            <mat-icon>close</mat-icon>
          </button>
          }
        </div>
      </div>
      <div class="filter-container">
        <mat-form-field class="project-filter-field" appearance="outline">
          <mat-select multiple [(ngModel)]="blueprintFilter" (selectionChange)="applyBlueprintFilter()"
            placeholder="Template" panelClass="project-filter-panel" [panelWidth]="null">
            <mat-select-trigger>
              {{ getBlueprintFilterDisplayName() }}
            </mat-select-trigger>
            @for (blueprint of relevantBlueprints; track blueprint.id) {
            <mat-option [value]="blueprint.id">
              {{ blueprint.name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field class="project-filter-field" appearance="outline">
          <mat-select multiple [(ngModel)]="projectOwnerFilter" (selectionChange)="applyProjectOwnerFilter()"
            placeholder="Project Owner" panelClass="project-filter-panel" [panelWidth]="null">
            <mat-select-trigger>
              {{ getOwnerFilterDisplayName() }}
            </mat-select-trigger>
            @for (owner of relevantProjectOwners; track owner.id) {
            <mat-option [value]="owner.id"> {{ owner.firstName }} {{ owner.lastName }}{{ owner.isActive ? '' : '
              (Inactive)' }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (blueprintFilter.length > 0 || projectOwnerFilter.length > 0) {
        <button mat-button class="clear-filters-button" (click)="onClearAllFilters()" matTooltip="Clear all filters">
          <mat-icon>clear</mat-icon>
        </button>
        }
      </div>
    </div>
    <div class="project-table-container" [hidden]="dataSourcePaged?.filteredData?.length === 0">
      <table mat-table #table [dataSource]="dataSourcePaged" matSort matSortActive="name" matSortDirection="asc"
        matSortDisableClear cdkFocusInitial>
        <ng-container matColumnDef="key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="projects-sticky-header" style="width: 5%">Project
            Key</th>
          <td mat-cell *matCellDef="let project" style="width: 5%" pTooltip="{{ project.id }}" showDelay="3000">
            <a class="clickable" (click)="onLoadProject(project.id)">{{ project.key }} </a>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="projects-sticky-header" mat-sort-header style="width: 10%">
            Project Name</th>
          <td mat-cell *matCellDef="let project" style="width: 10%">
            {{ project.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="createdDate">
          <th mat-header-cell *matHeaderCellDef class="projects-sticky-header" mat-sort-header style="width: 6%">Created
          </th>
          <td mat-cell matTooltip="{{ project.createdDate | date: 'dd/MM/yyyy HH:mm:ss' }}" *matCellDef="let project"
            style="width: 6%">
            {{ project.createdDate | date: 'dd/MM/yyyy' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="lastActivityDate">
          <th mat-header-cell *matHeaderCellDef class="projects-sticky-header" mat-sort-header style="width: 5%">Last
            Activity</th>
          <td mat-cell matTooltip="{{ project.lastActivityDate | date: 'dd/MM/yyyy HH:mm:ss' }}" *matCellDef="let project"
            style="width: 5%">
            {{ project.lastActivityDate | date: 'dd/MM/yyyy' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="percentageComplete">
          <th mat-header-cell *matHeaderCellDef class="projects-sticky-header" mat-sort-header style="width: 6%">%
            Complete</th>
          <td mat-cell *matCellDef="let project" style="width: 6%">
            {{ project.percentageComplete | percent: '1.1-1' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="integratedApps">
          <th mat-header-cell *matHeaderCellDef class="projects-sticky-header" mat-sort-header style="width: 18%">
            Integrations</th>
          <td mat-cell *matCellDef="let project" style="width: 18%">
            @for (app of project.integratedApps; track app) {
            <div style="display: flex; flex-direction: column">
              <div style="display: flex; flex-direction: row">
                @if (app.type === 'Jira') {
                <img src="assets/images/jira.png" matTooltip="{{ app.appName }}" class="img-icon" />
                } @if (app.type === 'Enterprise Tester' || app.type === 'Frankly') {
                <img src="assets/images/enterprisetester_black.png" matTooltip="{{ app.appName }}" class="img-icon" />
                }
                {{ app.mappedProject.name }}
              </div>
            </div>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef class="projects-sticky-header" mat-sort-header style="width: 35%">
            Description</th>
          <td mat-cell *matCellDef="let project" style="width: 30%; padding-right: 1rem">
            <!-- Shows the description with the formatting it was written with. Inline images are
                 left out of the preview by the pipe - see buildRichTextPreviewHtml. -->
            <div class="description-preview" [innerHTML]="project.description | richTextPreview : 200"></div>
          </td>
        </ng-container>
        <ng-container matColumnDef="bluePrint">
          <th mat-header-cell *matHeaderCellDef class="projects-sticky-header" mat-sort-header style="width: 10%">
            Template</th>
          <td mat-cell *matCellDef="let project" style="width: 10%">
            {{ project.bluePrintId | bluePrintName: allBluePrints }}
          </td>
        </ng-container>
        <ng-container matColumnDef="projectOwner">
          <th mat-header-cell *matHeaderCellDef class="projects-sticky-header" mat-sort-header style="width: 8%">Project
            Owner</th>
          <td mat-cell *matCellDef="let project" style="width: 8%">
            {{ getProjectOwner(project.owner) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="projects-sticky-header" style="width: 25%"></th>
          <td mat-cell *matCellDef="let project" style="text-align: center; width: 25%">
            <div class="action-cell">
              <div class="counts-pill">
                <span class="circled-count circled-count--green" matTooltip="Labels: {{ project.labelCount }}">{{ project.labelCount }}</span>
                <span class="circled-count circled-count--blue" matTooltip="Items: {{ project.nodeCount }}">{{ project.nodeCount }}</span>
                <span class="circled-count circled-count--orange" matTooltip="Wiki Docs: {{ project.wikiCount }}">{{ project.wikiCount }}</span>
              </div>
              <div [class.action-disabled]="!canReadAttachments(project.id)" (click)="onManageAttachments($event, project.id)">
                <mat-icon [matTooltip]="canReadAttachments(project.id) ? 'Manage Attachments' : 'You do not have permission'" class="att-style">attachment</mat-icon>
              </div>
              @if (project?.integratedApps?.length === 0) {
              <div [class.action-disabled]="!canCreateProject" (click)="onCloneProject($event, project.id)">
                <mat-icon [matTooltip]="canCreateProject ? 'Clone Project' : 'You do not have permission'">copy_all</mat-icon>
              </div>
              } @else {
              <div class="disabled-clone-button" click-stop-propagation>
                <mat-icon matTooltip="Cloning is disabled for integrated projects">copy_all</mat-icon>
              </div>
              }
              <div [class.action-disabled]="!canUpdateProject(project.id)" (click)="onEditProject($event, project.id)">
                <mat-icon [matTooltip]="canUpdateProject(project.id) ? 'Edit Project' : 'You do not have permission'">edit</mat-icon>
              </div>
              <div [class.action-disabled]="!canDeleteProject(project.id)" (click)="onDeleteProject($event, project)">
                <mat-icon [matTooltip]="canDeleteProject(project.id) ? 'Delete Project' : 'You do not have permission'">delete</mat-icon>
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row
          *matHeaderRowDef="['key', 'name', 'description', 'bluePrint', 'projectOwner', 'createdDate', 'lastActivityDate', 'percentageComplete', 'integratedApps', 'actions']">
        </tr>
        <tr mat-row
          *matRowDef="let p; columns: ['key', 'name', 'description', 'bluePrint', 'projectOwner', 'createdDate', 'lastActivityDate', 'percentageComplete', 'integratedApps', 'actions']"
          (click)="onLoadProject(p.id)"></tr>
      </table>
    </div>
    @if (dataSourcePaged?.filteredData?.length === 0) {
    <div class="no-results-message">No projects to display</div>
    }
    <mat-paginator [hidden]="dataSourcePaged?.filteredData?.length === 0" [pageSizeOptions]="[20, 30, 50]"
      showFirstLastButtons></mat-paginator>
    } @else {
    <div class="dashboard-container">
      <div class="dashboard-item project-allocation">
        <app-project-allocation [projectAllocationChartData]="projectAllocationChartData"></app-project-allocation>
      </div>
      <div class="dashboard-item section-with-text">
        <span class="completion-number count-number">{{ projectMetrics.averageCompletionDays }}</span>
        <div class="header-text">Days to Complete a Project</div>
      </div>
      <div class="dashboard-item project-status">
        <app-project-status [projectStatusData]="projectStatusData" [colorTheme]="colorTheme"></app-project-status>
      </div>
      <div class="dashboard-item new-project section-with-text">
        <span class="completion-number count-number">{{ projectMetrics.newProjectMonthCount }}</span>
        <div class="header-text">New Projects this month</div>
      </div>
      <div class="dashboard-item current-working-project">
        <app-current-working-project
          [currentWorkingProjectData]="currentWorkingProjectData"></app-current-working-project>
      </div>
      <div class="dashboard-item completed-project section-with-text">
        <span class="completion-number count-number">{{ projectMetrics.projectCompletionCountMonth }}</span>
        <div class="header-text">Projects completed this month</div>
        <div class="header-text">
          <span>{{ projectMetrics.projectCompletionCountYear }}</span> Completed this year
        </div>
      </div>
    </div>
    }
  </div>
</div>
<div class="div-progress">
  @if (isLoading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</div>
